import { AreYouSureModal } from "@tfg/ui"
import { AxiosError } from "axios"
import { useTranslation } from "react-i18next"

import {
  CONTACT_WITH_INFORMATION_REQUESTS_ERROR,
  ContactResponses,
} from "@tfg/types/endpoints/contacts"

import { useDeleteContactMutation } from "~/pages/SupplierPortal/Contacts/hooks/useDeleteContactMutation.ts"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

interface Props {
  isOpen: boolean
  onClose: () => void
  contact: ContactResponses.Contact
}

export const DeleteContactModal = ({ isOpen, onClose, contact }: Props) => {
  const { t } = useTranslation("supplier")

  const { mutate: deleteContact } = useDeleteContactMutation(contact.id, {
    onSuccess: () => {
      showSuccessNotification({
        message: t("contactModal.delete.success"),
        title: t("contactModal.delete.success"),
      })
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        showAxiosError({
          notificationTitle: t("contactModal.delete.error.title"),
          notificationMessage:
            error.response?.data === CONTACT_WITH_INFORMATION_REQUESTS_ERROR
              ? t("contactModal.delete.error.contactWithInformationRequests")
              : t("contactModal.delete.error.default"),
          showNotification: true,
          error,
        })
      }
    },
  })

  return (
    <>
      <AreYouSureModal
        opened={isOpen}
        onClose={onClose}
        title={t("contactModal.delete.title")}
        confirmText={t("contactModal.delete.confirm")}
        cancelText={t("contactModal.delete.cancel")}
        onConfirm={() => {
          deleteContact()
          onClose()
        }}
        areYouSureText={t("contactModal.delete.message")}
      />
    </>
  )
}
